<router-outlet *ngIf="!isLoading"></router-outlet>

